import { createAction, props } from '@ngrx/store';
const customerIsCreate = 'CUSTOMER_IS_CREATED';
const removeRecentCustomer = 'REMOVE_RECENT_CUSTOMER';
export const customerIsCreatedAction = createAction(
  customerIsCreate,
  props<{ newCustomer: any }>()
);
export const removeRecentCustomerAction = createAction(removeRecentCustomer);
